import React, { useState, useEffect } from "react";
import config from "../../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import moment from "moment";
import PrintHeader from '../../General/PrintHeader';
import Page from "../../General/Page";
import { getMonthName } from '../../General/Utility';


const PrintTaxList1 = () => {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [listOfLedger, setLedger] = useState([]);
    const [selectedYear, setselectedYear] = useState("");
    const [selectedMonth, setselectedMonth] = useState("");
    const [selectedAmount, setAmount] = useState(0);


    useEffect(() => {
        document.title="DPS School Management System"

        setLoading(true);
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // Retrieve individual parameter values
        const year = urlParams.get('year');
        const Month = urlParams.get('month');
        const EmployeeTypeId = urlParams.get('EmployeeTypeId');
        const Amount = urlParams.get('Amount');


        setselectedYear(year);
        setselectedMonth(Month);
        setAmount(Amount);

        const data = {
           AccessKey: AccessKey,
            UserID: UserID,
MemberType: MemberType,
            Fyear: year,
            SelectedMonth: Month,
            EmployeeTypeId: EmployeeTypeId,
            Amount: Amount,
        };



        // console.log(data);
        var api_config = {
            method: 'post',
            url: config.base_url + 'Payroll/GetTaxList1',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        console.log(data);

        axios(api_config)
            .then(function (response) {
                console.log(response.data);
                setLedger(response.data.ListofRecords);
                setLoading(false);


            })
            .catch(function (error) {
                console.log(error);
            });

    }, []);

    const renderLedger = () => {

        if (listOfLedger.length > 0) {
            let count = 1;
            // let countbreak = 1;
            return (
                listOfLedger.map((item, index) => {
                    const isPageBreak = index > 0 && index % 18 == 0;
                    return (
                        <tr key={index}  className={isPageBreak ? 'page-break' : ''}>
                            <td>
                                {count++}
                            </td>
                            <td>{item.SelectedEmployee?.Code}</td>
                            <td>{item.SelectedEmployee?.Name}</td>
                            <td>{item.SelectedEmployee?.Father_Name}</td>
                            <td>{item.SelectedEmployee?.SelectedDesignation?.Name}</td>
                            <td>{item.SelectedEmployee?.Qualification}</td>
                            <td>{item.SelectedEmployee?.GPS_Scale}</td>
                            <td>{item.SelectedEmployee?.CNIC_NO}</td>
                            <td>{item.Gross}</td>
                            <td></td>
                            <td>{item.SelectedEmployee?.Mobile_No}</td>
                            <td></td>
                        </tr>

                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colspan="12"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }


    return (
        <>
            <Page orientation="landscape" size="legal">

                <table className="table print-main-table">
                    <thead>
                        <tr>
                            <td>
                                <PrintHeader title={`INCOME TAX DETAILS For the Month of ${getMonthName(selectedMonth)} ${selectedYear} `} />
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                            <td>
                                <table className="table table-sm table-bordered table-print">
                                    <tbody>


                        <tr>

                            <th>Sr.#</th>
                            <th>Code</th>
                            <th>Staff Name </th>
                            <th>Father Name </th>
                            <th>Designation</th>
                            <th>Qualification </th>
                            <th>BPS </th>
                            <th>CNIC No. </th>
                            <th>Gross </th>
                            <th>Tax Paid </th>
                            <th>Mobile No </th>
                            <th>Remarks</th>

                        </tr>
                        {
                            loading ?
                                <tr>
                                    <td className="text-center" colspan="12">
                                        <Spinner animation="border" role="status"></Spinner>
                                    </td>
                                </tr>
                                :
                                <>
                                    {renderLedger()}

                                </>

                        }

                    </tbody>
                </table>
                </td>
                        </tr>


                    </tbody>
                </table>

            </Page>
        </>
    );
}

export default PrintTaxList1;
